import { useState, useCallback } from 'react';
import { getHistorial, actualizarEstado } from '../services/enviosService';

export function useHistorial(handleError) {
  const [historial, setHistorial] = useState([]);
  const [loadingUpdate, setLoadingUpdate] = useState(false);

  // 🔹 Obtener historial de un envío
  const fetchHistorial = useCallback(async (id) => {
    if (!id) return { success: false, historial: [], mensaje: 'ID inválido' };
    try {
      const res = await getHistorial(id);

      if (!res || res.success === false) {
        const mensaje = res?.mensaje || '❌ Error al cargar historial';
        if (handleError) handleError(mensaje);
        setHistorial([]);
        return { success: false, historial: [], mensaje };
      }

      const data = Array.isArray(res.historial) ? res.historial : [];
      setHistorial(data);
      return { success: true, historial: data, mensaje: res.mensaje || '✅ Historial cargado' };
    } catch (err) {
      const mensaje = err?.message || '❌ Error al cargar historial';
      if (handleError) handleError(mensaje);
      setHistorial([]);
      return { success: false, historial: [], mensaje };
    }
  }, [handleError]);

  // 🔹 Actualizar estado de un envío
  const updateEstado = useCallback(async (id, estado, onSuccess) => {
    try {
      setLoadingUpdate(true);
      const res = await actualizarEstado(id, estado);

      if (!res || res.success === false) {
        const mensaje = res?.mensaje || '❌ Error al actualizar estado';
        if (handleError) handleError(mensaje);
        return { success: false, mensaje };
      }

      // refrescar historial después de actualizar
      await fetchHistorial(id);
      if (onSuccess) onSuccess(res.envio); // ✅ solo pasamos el envio normalizado
      return { success: true, mensaje: res.mensaje || '✅ Estado actualizado', envio: res.envio || null };
    } catch (err) {
      const mensaje = err?.message || '❌ Error al actualizar estado';
      if (handleError) handleError(mensaje);
      return { success: false, mensaje };
    } finally {
      setLoadingUpdate(false);
    }
  }, [fetchHistorial, handleError]);

  return { historial, fetchHistorial, loadingUpdate, updateEstado };
}